module.exports = "img/flags/GN.81c74d2.png";